import {AsiDialogView} from "@asi-ngtools/lib";
import {Component} from "@angular/core";

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm.modal.html'
})
export class ConfirmModal extends AsiDialogView {
  title: string;
  question: string;
  confirmButton: string;
  cancelButton: string;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/modal/confirm/confirm.modal.ts